import { USER_STATUS } from "Common/dictionaries/userStatus";
import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "users";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const NEW_USER = {
    Id: 0,
    Login: "",
    FirstName: "",
    LastName: "",
    MiddleName: "",
    Password: "",
    RepeatPassword: "",
    Department: "",
    RoleId: 0,
    RoleLocale: "",
    Email: "",
    Status: USER_STATUS.ACTIVE
};
export const MAX_FILE_SIZE = 5242880;
export const ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png"];
